import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CanvasContext = createContext<any>(null);
